module.exports = __webpack_public_path__ + "html/overlay.component.html";